// src/components/HomeAbout/HomeAbout.js
import React, { useState } from 'react';
import './HomeAbout.css';
import ResumePopup from './ResumePopup/ResumePopup';
import ProfileImage from '../../Assets/images/profile-portfolio.jpg';

const HomeAbout = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  return (
    <section className="homeabout-container">
      <div className="homeabout-image-wrapper">
        <img
          src={ProfileImage}
          alt="Srihari Muppalla"
          className="homeabout-image"
        />
      </div>
      <div className="homeabout-content">
        <h1 className="homeabout-name">Srihari Muppalla</h1>
        <h2 className="homeabout-designation">
          Full Stack Developer | Web Developer | Email Developer
        </h2>
        <p className="homeabout-description">
          Experienced developer specializing in creating responsive websites and engaging email campaigns that drive conversions. With a strong foundation in HTML, CSS, JavaScript, React.js, Node.js, and email development tools like Litmus and Salesforce, I focus on delivering high-quality, user-centric solutions. Passionate about staying updated with the latest industry trends to enhance digital strategies and user engagement.
        </p>
        <button className="homeabout-resume-btn" onClick={openPopup}>
          View Resume
        </button>
      </div>
      {isPopupOpen && <ResumePopup onClose={closePopup} />}
    </section>
  );
};

export default HomeAbout;